<template>
  <div>
    <b-modal
      id="version-modal"
      ref="modal"
      header-class="headerModal"
      centered
      :title="$t('version-popup-title')"
      no-close-on-backdrop
      hide-footer
      @hide="hide"
    >
      <p>{{ $t('version-info') }}</p>
      <div>
        <b-button
          type="button"
          variant="danger"
          class="buttonSubmit"
          @click="onUpdateVersion"
          style="margin-bottom: 10px;"
        >
          {{ $t('version-update') }}
        </b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import router from '@/router';
import getConnection from '@/microsoft-signalR/signalR';
import { mapActions } from 'vuex';

export default {
  name: 'VersionModal',
  methods: {
    ...mapActions(['logoutUser']),
    async updateApp() {
      const res = await fetch('/version.json', { cache: 'no-store' })
      const { version } = await res.json()

      localStorage.setItem('appVersion', version)
      localStorage.removeItem('pinia')
      localStorage.removeItem('tenant')
      localStorage.removeItem('signupData');
      localStorage.removeItem('modalShownBefore');
      await router.push('/login')
      window.location.reload()
    },
    show() {
      this.$refs.modal.show();
    },
    hide() {
      this.$refs.modal.hide();
    },
    onUpdateVersion() {
      const connection = getConnection();
      connection.stop();
      this.logoutUser().then(() => {
        this.updateApp()
      });
      this.onCancel()
    },
  },
}
</script>
